/**
 * NavButton Component
 * 
 * Reusable navigation button with icon and label
 */
import React from 'react';

function NavButton({ icon, label, active, onClick, testId, vertical = false }) {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center gap-1 px-4 py-2 rounded-button transition-all ${
        active ? 'text-primary bg-primary/10' : 'text-gray-500 hover:text-primary'
      }`}
      data-testid={testId}
      title={label}
    >
      <span className={vertical ? 'text-2xl' : 'text-2xl'}>{icon}</span>
      <span className="text-xs font-semibold">{label}</span>
    </button>
  );
}

export default NavButton;
